import React from "react"

const WorldPayCancel = () => {
  return <div>WorldPayCancel</div>
}

export default WorldPayCancel
